//$FlowFixMe
import React from 'react';
import Axios, { AxiosResponse, AxiosError } from "axios";
import { type PaginationProps } from "antd/lib/pagination";

export type DataType = "string" | "number" | "date";

export const TableApi = {
  FETCH_SCHEMA: "/api/webapp/get-table-schema",
  FETCH_TABLE_DATA: "/api/webapp/get-table-data",
  SAVE_TABLE_RECORD: "/api/webapp/save-table-record",
  GET_TABLE_FILTERS: "/api/webapp/get-table-filters",
  GET_ACTION_DATA: "api/webapp/get-action-details/",
  POST_ACTION: "api/webapp/take-action/"
};
export type Column = {
  title: string,
  dataIndex: string,
  key: string,
  type: DataType
};

export type ActionDropDown = {
  confirm: boolean,
  key: string,
  label: string,
  multipleRowSelection: boolean
}

export default class TableSchema {
  _key: string;
  _success: (ts: TableSchema) => void;
  _columnSchema: Column[];
  _error: AxiosError;
  _fetchDataSuccess: (ts: TableSchema) => void;
  _tableData: Object;
  _editable: boolean;
  _actionData: ActionDropDown[];
  _fetchActionDataSuccess: (ts: TableSchema) => void;

  constructor(key: string) {
    this._key = key;
  }

  getTableKey(): string {
    return this._key;
  }

  handleResponse = (response: AxiosResponse) => {
    if (response.data["entries"]) {
      this._columnSchema = response.data["entries"];
      this._columnSchema = this._columnSchema?.map((item) => {
        return {
          ...item, width: 100, render: (text) => (
            <div style={{ wordWrap: 'break-word', wordBreak: 'break-word' }}>
              {text}
            </div>
          )
        }
      })
    }
    this._editable = response.data["editable"] === true;
    this._success(this);
  };

  handleError = (error: AxiosError) => {
    console.log(error);
    this._error = error;
    this._success(this);
  };

  isError(): boolean {
    return !!this._error === true;
  }

  getActionDropDown() {
    return this._actionData;
  }

  getColumns() {
    return this._columnSchema;
  }

  getColumnnsCount() {
    return this._columnSchema ? this._columnSchema.length : 0;
  }

  getColumnKey(index: number): string {
    const column: Column = this._columnSchema[index];
    return column.key;
  }

  getColumnLabel(index: number): string {
    const column: Column = this._columnSchema[index];
    return column.title;
  }

  getColumnType(index: number): DataType {
    const column: Column = this._columnSchema[index];
    return column.type;
  }

  isTableEditable(): boolean {
    return this._editable;
  }

  run(): Promise<TableSchema> {
    return new Promise((success, failure) => {
      this._success = success;
      const axios = Axios.get(TableApi.FETCH_SCHEMA + "/" + this._key);
      axios.then(this.handleResponse).catch(this.handleError);
    });
  }

  handleFetchDataResponse = (response: AxiosResponse) => {
    this._tableData = response.data;
    this._fetchDataSuccess(this);
  };

  getTableDataEntries(): Object[] {
    return this._tableData.hasOwnProperty("entries") ? this._tableData["entries"] : [];
  }

  getTotal(): number {
    return this._tableData.total;
  }

  fetchData(pagination: PaginationProps, filterValues: Object = {}): Promise<TableSchema> {
    const jsonFilterParams = filterValues ? JSON.stringify(filterValues) : "{}";
    const encodedFilterParam: string = encodeURIComponent(jsonFilterParams);
    return new Promise((success, failure) => {
      this._fetchDataSuccess = success;
      const axios = Axios.get(
        TableApi.FETCH_TABLE_DATA +
        "/" +
        this._key +
        "?start=" +
        (pagination.current - 1) * pagination.pageSize +
        "&limit=" +
        pagination.pageSize +
        "&filterParams=" +
        encodedFilterParam
      );
      axios.then(this.handleFetchDataResponse).catch(this.handleError);
    });
  }

  handleActionDataResponse = (response: AxiosResponse) => {
    this._actionData = response.data["entries"];
    this._fetchActionDataSuccess(this);
  }

  fetchActionData(_id: string) {
    return new Promise((success, failure)=> {
      this._fetchActionDataSuccess = success;
      const axios = Axios.get(TableApi.GET_ACTION_DATA + this._key);
      axios.then(this.handleActionDataResponse).catch(this.handleError)
    })
  }
}
